<template>
  <el-dialog :title="!dataForm.id ? '新增' : '修改'"
             :close-on-click-modal="false"
             :visible.sync="visible">
    <el-form :model="dataForm"
             :rules="dataRule"
             ref="dataForm"
             @keyup.enter.native="dataFormSubmit()"
             label-width="80px">
      <el-form-item label="配置描述"
                    prop="descs">
        <el-input v-model="dataForm.descs"
                  placeholder="配置描述"></el-input>
      </el-form-item>
      <el-form-item label="值"
                    prop="valuess">
        <el-input v-model="dataForm.valuess"
                  placeholder="值"></el-input>
      </el-form-item>
    </el-form>
    <span slot="footer"
          class="dialog-footer">
      <el-button @click="visible = false">取消</el-button>
      <el-button type="primary"
                 @click="dataFormSubmit()">确定</el-button>
    </span>
  </el-dialog>
</template>

<script>
export default {
  data () {
    return {
      visible: false,
      dataForm: {
        id: 0,
        descs: '',
        valuess: ''
      },
      dataRule: {
        descs: [
          { required: true, message: '配置描述不能为空', trigger: 'blur' }
        ],
        values: [
          { required: true, message: '值不能为空', trigger: 'blur' }
        ]
      }
    }
  },
  methods: {
    init (id) {
      this.dataForm.id = id || 0
      this.visible = true
      this.$nextTick(() => {
        this.$refs['dataForm'].resetFields()
        console.log(this.dataForm.id)
        this.$http({
          url: this.global.apiUrl + `/jxjg/jgconfig/info/` + this.dataForm.id,
          method: 'get',
          params: {
            'id': this.dataForm.id
          }
        }).then((data) => {
          data = data.body
          if (data && data.code === 0) {
            this.dataForm.descs = data.jgconfig.descs
            this.dataForm.valuess = data.jgconfig.valuess
          }
        })
      })
    },
    // 表单提交
    dataFormSubmit () {
      this.$refs['dataForm'].validate((valid) => {
        if (valid) {
          this.$http({
            url: this.global.apiUrl + `/jxjg/jgconfig/${!this.dataForm.id ? 'save' : 'update'}`,
            method: 'post',
            params: {
              'id': this.dataForm.id || undefined,
              'descs': this.dataForm.descs,
              'valuess': this.dataForm.valuess
            }
          }).then((data) => {
            data = data.body
            if (data && data.code === 0) {
              this.$message({
                message: '操作成功',
                type: 'success',
                duration: 1500,
                onClose: () => {
                  this.visible = false
                  this.$emit('refreshDataList')
                }
              })
            } else {
              this.$message.error(data.msg)
            }
          })
        }
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/jgconfig-add-or-update.vue